import { IHistoryConfig } from "src/Interfaces/history";
import { getRequest, getTable, postRequest } from "./requestTemplates";
import { Packet } from "src/Interfaces/commonDtos";
import { Report } from "src/Interfaces/TableInterfaces";

export const getHistoryConfig = (): Promise<IHistoryConfig> =>
  getRequest("/v1/history/getConfig");

export const setHistoryConfig = (
  formValues: IHistoryConfig
): Promise<Packet<boolean>> => postRequest("/v1/history/setConfig", formValues);

export const syncHistoryData = (): Promise<Packet<boolean>> =>
  getRequest("/v1/history/syncData");

export const getHistoryTable = (
  _: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable(`/v1/history/table`, {}, offset, pageSize, sortingType);
